import React, { useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import { css, keyframes } from 'emotion';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function random() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return Math.round(Math.random() * n);
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  0% { transform: translate3d(0, 0, 0) rotateX(0) rotateY(0); }\n  100% { transform: translate3d(-50px, ", ", 0) rotateX(10deg) rotateY(250deg); }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  0% { transform: translate3d(0, 0, 0) rotateX(0) rotateY(0); }\n  100% { transform: translate3d(100px, ", ", 0) rotateX(100deg) rotateY(360deg); }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  0% { transform: translate3d(0, 0, 0) rotateX(0) rotateY(0); }\n  100% { transform: translate3d(-25px, ", ", 0) rotateX(360deg) rotateY(180deg); }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: -10px;\n  will-change: transform;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var wrapper = css(_templateObject());
var particle = css(_templateObject2());

var Slow = function Slow(height) {
  return keyframes(_templateObject3(), height);
};

var Medium = function Medium(height) {
  return keyframes(_templateObject4(), height);
};

var Fast = function Fast(height) {
  keyframes(_templateObject5(), height);
};

var styles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  wrapper: wrapper,
  particle: particle,
  Slow: Slow,
  Medium: Medium,
  Fast: Fast
});
var defaultProps = {
  colors: ["#F6F0FD", "#E3D0FF", "#9C6ADE", "#50248F", "#230051"],
  types: ["Slow", "Medium", "Fast"],
  duration: 10,
  particles: 200,
  launch: false
};

function Konfettikanone(props) {
  var _defaultProps$props = _objectSpread2({}, defaultProps, {}, props),
      colors = _defaultProps$props.colors,
      className = _defaultProps$props.className,
      duration = _defaultProps$props.duration,
      launch = _defaultProps$props.launch,
      particles = _defaultProps$props.particles,
      types = _defaultProps$props.types,
      onLaunchEnd = _defaultProps$props.onLaunchEnd;

  var confettiWrapper = useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      confetti = _useState2[0],
      setConfetti = _useState2[1];

  var mergedClass = classNames(wrapper, className);

  function getRandomParticle() {
    var _confettiWrapper$curr, _confettiWrapper$curr2;

    var wrapperHeight = (confettiWrapper === null || confettiWrapper === void 0 ? void 0 : (_confettiWrapper$curr = confettiWrapper.current) === null || _confettiWrapper$curr === void 0 ? void 0 : _confettiWrapper$curr.offsetHeight) || 0;
    var wrapperWidth = confettiWrapper === null || confettiWrapper === void 0 ? void 0 : (_confettiWrapper$curr2 = confettiWrapper.current) === null || _confettiWrapper$curr2 === void 0 ? void 0 : _confettiWrapper$curr2.offsetWidth;
    var relativeDuration = duration * wrapperHeight;
    var animationTime = relativeDuration * 0.4;
    var delay = Math.random() * (relativeDuration - animationTime);
    var animationDurations = [animationTime, animationTime * 0.8, animationTime * 0.7];
    var randomDuration = animationDurations[random(animationDurations.length - 1)];
    var randomColor = colors[random(colors.length - 1)];
    var randomStyle = types[random(types.length - 1)];
    var baseSize = 7;
    var baseSizeVariance = 3;
    return {
      height: "".concat(random(baseSizeVariance) + baseSize, "px"),
      width: "".concat(random(baseSizeVariance) + baseSize, "px"),
      left: "".concat(random(wrapperWidth), "px"),
      backgroundColor: randomColor,
      animation: "".concat(styles[randomStyle]("".concat(wrapperHeight + baseSize + baseSizeVariance, "px")), " ").concat(randomDuration, "ms linear ").concat(delay, "ms 1 forwards")
    };
  }

  function createConfetti() {
    return _toConsumableArray(Array(particles)).map(function (_x, index) {
      var randomStyle = getRandomParticle();
      return React.createElement("div", {
        key: index,
        style: randomStyle,
        className: particle
      });
    });
  }

  useEffect(function () {
    if (launch && confettiWrapper.current != null) {
      var _confettiWrapper$curr3;

      setConfetti(createConfetti());
      var timer = setTimeout(function () {
        if (onLaunchEnd) {
          onLaunchEnd();
        }
      }, duration * (confettiWrapper === null || confettiWrapper === void 0 ? void 0 : (_confettiWrapper$curr3 = confettiWrapper.current) === null || _confettiWrapper$curr3 === void 0 ? void 0 : _confettiWrapper$curr3.offsetHeight));
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [confettiWrapper, launch]);
  return React.createElement(React.Fragment, null, launch ? React.createElement("div", {
    ref: confettiWrapper,
    className: mergedClass
  }, confetti) : null);
}

export { Konfettikanone };